/* eslint-disable react/prop-types */
import React, { useCallback } from 'react'

import { CheckCircle, CloudArrowUp } from 'react-bootstrap-icons'
import { useDropzone } from 'react-dropzone'

import { FileInputProps } from './FileInput.types'

import './FileInput.scss'

export const FileInput: React.FC<FileInputProps> = ({ 
  disabled, 
  onChange, 
  inputProps,
  accept=undefined,
  mode='file',
}) => {

  const onDrop = useCallback((acceptedFiles) => {
    const files = mode === 'file' ? acceptedFiles[0] : acceptedFiles
    
    onChange && onChange(files)
  }, [mode, onChange])

  const { acceptedFiles, getRootProps, getInputProps, isDragActive, inputRef, rootRef } = useDropzone({
    onDrop,
    useFsAccessApi: mode === 'file',
    accept: accept ? {
      'multipart/form-data': accept,
    } : undefined,
    disabled,
  })

  const formatDescription = useCallback(() => {
    const file = acceptedFiles[0] 
    return file.name
  }, [acceptedFiles])

  return (
    <div {...getRootProps({ className: disabled ? 'poll-drop-zone-disabled' : 'poll-drop-zone' })}>
      <div
        style={{
          display: 'flex',
          gap: 16,
          alignItems: 'center',
          flex:18,
          minWidth: 0
        }}
      >
        { acceptedFiles?.length > 0 ?
          <CheckCircle size={32} style={{ color: '#687075' }} />
          :
          <CloudArrowUp size={32} style={{ color: '#687075' }} />
        }
        <div style={{
          display: 'flex',
          justifyItems: 'flex-start',
          textAlign: 'start',
          flexDirection: 'column',
          gap: 2,
          minWidth: 0,
        }}
        >
          <label
            htmlFor={inputProps && inputProps.name ? inputProps.name : undefined}
            style={{ 
              marginBottom: 0,
              cursor: disabled ? 'default' : 'pointer'
            }}
          >
            {mode === 'file' && 'Drag and drop files here'}
            {mode === 'folder' && 'Drag and drop a folder here'}
          </label>
          <label 
            className="secondary"
            htmlFor={inputProps && inputProps.name ? inputProps.name : undefined}
            style={{
              cursor: disabled ? 'default' : 'pointer'
            }}
          >
            {acceptedFiles?.length > 0 ?
              <>
                {mode === 'file' 
                  ? formatDescription()
                  : `${acceptedFiles?.length} file${acceptedFiles?.length > 1 ? 's' : ''} uploaded`}
              </>
              :
              <>
                Accepts: {accept ? accept.reduce((p,c,i,a) => {
                  if (i === 0) return `${c} `
                  return i === a.length - 1 ? `${p} or ${c} ` : `${p}, ${c}`
                }, '') : '.* '}
              </>
            }
          </label>
        </div>
      </div>
      <label 
        htmlFor={inputProps && inputProps.name ? inputProps.name : undefined}
        style={{
          flex:6,
          justifyContent:'center',
          maxWidth: 140,
          cursor: disabled ? 'default' : 'pointer'
        }}
        className={`poll-file-input-button ${disabled && 'poll-file-input-button-disabled'}`}>
          Browse
      </label>
      {mode === 'file' && <input type="file" multiple={false} {...inputProps} {...getInputProps() } />}
      {/* @ts-ignore */}
      {mode === 'folder' && <input type="file" multiple={true} {...inputProps} {...getInputProps({ webkitdirectory: 'true' })}/>}
    </div>
  )
}

export default FileInput
